/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListPromptSnippetReferencesPathParams = NonNullable<
  operations['listPromptSnippetReferences']['parameters']['path']
>;

export type ListPromptSnippetReferencesQueryParams = NonNullable<
  operations['listPromptSnippetReferences']['parameters']['query']
>;

export interface Input extends ListPromptSnippetReferencesPathParams {
  apiVersion?: string;
  query?: ListPromptSnippetReferencesQueryParams;
}

export async function listPromptSnippetReferences(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/ai-configs/prompt-snippets/{snippetKey}/references', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
